<template>
  <div>
    <Select
      v-model="selectedCompany"
      :options="companies"
      option-label="name"
      scroll-height="500px"
      :disabled="loading && !companies"
      filter
      style="min-width: 10rem"
      class="mr-3"
      @update:model-value="setCompanyAndReload"
    />
  </div>
</template>

<script lang="ts">
import CompanyApi from '@/data/companies/CompanyApi.ts';
import { useCompanyStore } from '@/stores/CompanyStore.ts';
import Company from '@/domain/model/business/Company.ts';
import HardReload from '@/presentation/mixins/HardReload.js';

export default {
  name: 'CompanyPicker',
  mixins: [HardReload],
  data() {
    return {
      companies: null,
      loading: true,
      selectedCompany: null,
    };
  },
  mounted() {
    this.fillCompanies();
    this.$watch(() => useCompanyStore().company, this.handleCompanyChanged);
  },
  methods: {
    handleCompanyChanged(newCompany: Company) {
      this.selectedCompany = newCompany;
    },
    fillCompanies() {
      this.loading = true;
      const companySorter = (c1, c2) => c1.name.localeCompare(c2.name);

      new CompanyApi()
        .forwardToErrorPageOnException()
        .all()
        .then((response) => {
          this.companies = response.data.sort(companySorter).map((json) => {
            return Company.fromJson(json);
          });

          const storedCompany = useCompanyStore().company;
          if (storedCompany) {
            this.selectedCompany = this.companies.find(
              (c) => c.id === storedCompany.id,
            );
            this.loading = false;
          }
        });
    },
    setCompanyAndReload(company: Company) {
      useCompanyStore().set(company);
      this.reload('Dashboard');
    },
  },
};
</script>
